<template>
  <div class="content">
    <div class="top">
      <div class="header">
        <img alt="logo" class="logo" src="../../assets/logo.jpeg" />
        <span class="title">CloudCat</span>
      </div>
      <div class="desc"></div>
    </div>
    <el-card class="login">
      <el-form ref="form" :model="form" :rules="rules" style="margin: 15px;">
        <el-form-item prop="name">
          <el-input v-model="form.name" placeholder="请输入用户名">
            <i slot="prefix" class="el-icon-user" />
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="logging"
            style="width: 100%"
            type="primary"
            @click="reset_request('form')"
          >重置密码</el-button>
        </el-form-item>
        <a href="#/login">登陆</a>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logging: false,
      form: {
        name: "",
        password: "jarvis",
      },
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
      },
    };
  },
  methods: {
    reset_request(formName) {
      const _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.$axios
            .post(_this.config.path + "/auth/reset-password", _this.form)
            .then(function (response) {
              if (response.data.success === true) {
                _this.$message({
                  showClose: true,
                  message: "重置密码邮件已发送至你的邮箱，去邮箱查看吧",
                  type: "success",
                });
              } else {
                _this.$message({
                  showClose: true,
                  message: "重置请求失败: " + response.data.message,
                  type: "error",
                });
              }
            })
            .catch(function (err) {
              _this.$message({
                showClose: true,
                message: "重置请求失败: " + err.toString(),
                type: "error", 
              });
            });
        }
      });
    },
  },
};
</script>

<style>
.content {
  padding: 32px 0;
  flex: 1;

  @media (min-width: 768px) {
    padding: 112px 0 24px;
  }
}

.top {
  text-align: center;
}

.header {
  height: 44px;
  line-height: 44px;
}

.logo {
  height: 44px;
  vertical-align: top;
  margin-right: 16px;
}

.title {
  font-size: 33px;
  color: rgba(0, 0, 0, 0.85);
  font-family: "Myriad Pro", "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-weight: 600;
  position: relative;
  top: 2px;
  margin-bottom: 16px;
}

.login {
  width: 368px;
  margin: 0 auto;

  @media screen and (max-width: 576px) {
    width: 95%;
  }

  @media screen and (max-width: 320px) {
    .captcha-button {
      font-size: 14px;
    }
  }
}

.icon {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.2);
  margin-left: 16px;
  vertical-align: middle;
  cursor: pointer;
  transition: color 0.3s;
}

.desc {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 12px;
  margin-bottom: 40px;
}

&:hover {
  color: #1890ff;
}
</style>